import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SignalField} from '@models/pages/interactive-data-analysis/interactive-data-analysis-signals';
import {InteractiveDataAnalysisConfig} from '@models/pages/interactive-data-analysis/interactive-data-analysis-config';
import {InteractiveDataAnalysisProperty} from '@models/pages/interactive-data-analysis/interactive-data-analysis-property';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-edit-signal',
    templateUrl: './edit-signal.component.html',
    styleUrls: ['./edit-signal.component.scss'],
    standalone: false
})
export class EditSignalComponent implements OnInit, OnChanges {

  @Input()
  public signal: SignalField | undefined = undefined;

  @Input()
  public index: number = 0;

  @Input()
  public interactiveDataAnalysisConfig: InteractiveDataAnalysisConfig = new InteractiveDataAnalysisConfig();

  public interactiveDataAnalysisProperty: InteractiveDataAnalysisProperty = new InteractiveDataAnalysisProperty(this.signal?.color);

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.setInteractiveDataAnalysisProperty();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setInteractiveDataAnalysisProperty();
  }

  public get showColorPicker(): boolean {
    return this.interactiveDataAnalysisProperty.color !== '';
  }

  public get signalClass(): string {
    if (this.signal?.machineSignal) {
      return 'configured-signal';
    } else {
      return 'unconfigured-signal';
    }
  }

  public get axisPosition(): string {
    if (this.index % 2 === 0) {
      return 'left';
    }
    return 'right';
  }

  public get customAxisClass(): string {
    return this.interactiveDataAnalysisProperty.customRange ? '' : 'd-none';
  }

  getPositionTooltip(): string {
    return this.translateService.instant('Column is ' + this.axisPosition + ' aligned');
  };

  public onSelectedColor(color: string): void {
    this.interactiveDataAnalysisProperty.color = color;
  }

  private setInteractiveDataAnalysisProperty(): void {
    if (!this.signal || !this.interactiveDataAnalysisConfig) {
      return;
    }
    const configProps = this.interactiveDataAnalysisConfig.properties;
    if (configProps && configProps.get(this.signal.id)) {
      this.interactiveDataAnalysisProperty = configProps.get(this.signal.id) as InteractiveDataAnalysisProperty;
      if (this.interactiveDataAnalysisProperty.color === '') {
        this.interactiveDataAnalysisProperty.color = '#ccc';
      }
      return;
    }

    this.initializeInteractiveDataAnalysisProperty();
  }

  private initializeInteractiveDataAnalysisProperty(): void {
    this.interactiveDataAnalysisProperty = new InteractiveDataAnalysisProperty(this.signal?.color);
  }
}
